import type { IPerson } from 'src/interfaces';

export const getPersonName = ({ firstName, lastName }: Pick<IPerson, 'firstName' | 'lastName'>) =>
  [firstName, lastName].filter(Boolean).join(' ');
